/**
 * Nmeth Proposal Report Service
 * 方法論提案申請表報告 API 服務
 */

import axios from '../api/axios';

export interface FieldCompleteness {
  key: string;
  label_zh: string;
  label_en: string;
  max_score: number;
  score: number;
  filled: boolean;
}

export interface NmethCompletenessData {
  proposal_id: number;
  proposal_title: string;
  overall_percentage: number;
  fields: FieldCompleteness[];
}

const BASE_URL = '/api/nmeth-report';

export const getNmethCompleteness = async (proposalId: number): Promise<NmethCompletenessData> => {
  const res = await axios.get<NmethCompletenessData>(`${BASE_URL}/completeness/${proposalId}`);
  return res.data;
};

export const getNmethHtmlReport = async (proposalId: number): Promise<string> => {
  const res = await axios.get<string>(`${BASE_URL}/html/${proposalId}`, {
    responseType: 'text',
  });
  return res.data;
};

export const downloadNmethDocxReport = async (proposalId: number, filename: string): Promise<void> => {
  const res = await axios.get(`${BASE_URL}/docx/${proposalId}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(
    new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export default { getNmethCompleteness, getNmethHtmlReport, downloadNmethDocxReport };
